// In production (Docker), API calls go through nginx reverse proxy as relative /api
// In development, use localhost:4000
const API_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : 'http://localhost:4000';

export default API_URL;
